import { useTranslation } from "@i18n";

function LicenceWarning() {
  const { t } = useTranslation();
  return (
    <div className="top-0 z-99999 w-full bg-[red] py-3 text-center text-white">
      {t("Licensing error. Please contact your administrator or try accessing the application after some time.")}
    </div>
  );
}

export default LicenceWarning;
